import { httpRequest } from "@follaw-fr/utils/request.utils";
import { handleNetworkError } from "@follaw-fr/utils/handleNetworkError";
import type {
  CreateOnboardingDashboardAndDigestResponse,
  GetOnboardingThematicsResponse,
  CreateOnboardingDashboardAndDigestPayload,
} from "@commons/types/api/api.types";

/**
 * Fetches thematic data for a specific user.
 * @param userId - userId whose thematics are to be fetched.
 */

/** Fetch thematics for a sector */
export const getOnboardingThematics = async () => {
  try {
    const response = await httpRequest<GetOnboardingThematicsResponse, never>(
      "get",
      `/onboarding/get-thematics`
    );
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};

/** Submit selected thematics for dashboard creation */
export const createOnboardingDashboardAndDigest = async (
  payload: CreateOnboardingDashboardAndDigestPayload
) => {
  try {
    const response = await httpRequest<
      CreateOnboardingDashboardAndDigestResponse,
      CreateOnboardingDashboardAndDigestPayload
    >("post", "/onboarding/dashboard-and-digest", payload);
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};

export const setOnboardingCompleted = async () => {
  try {
    const response = await httpRequest("post", "/onboarding/completed");
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};
